import type { EventName } from "@lit/react";
import { MenuBar as MenuBarElement, type MenuBarEventMap as _MenuBarEventMap, } from "@vaadin/menu-bar/vaadin-menu-bar.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { MenuBarElement, };
export type MenuBarEventMap = Readonly<{
    onItemSelected: EventName<_MenuBarEventMap["item-selected"]>;
}>;
const events = { onItemSelected: "item-selected" } as MenuBarEventMap;
export type MenuBarProps = WebComponentProps<MenuBarElement, MenuBarEventMap>;
export const MenuBar = createComponent({
    elementClass: MenuBarElement, events, react: React, tagName: "vaadin-menu-bar"
});
